import { render, staticRenderFns } from "./SsoUnpaidView.vue?vue&type=template&id=d3da8174&scoped=true"
import script from "./SsoUnpaidView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SsoUnpaidView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SsoUnpaidView.vue?vue&type=style&index=0&id=d3da8174&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3da8174",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3da8174')) {
      api.createRecord('d3da8174', component.options)
    } else {
      api.reload('d3da8174', component.options)
    }
    module.hot.accept("./SsoUnpaidView.vue?vue&type=template&id=d3da8174&scoped=true", function () {
      api.rerender('d3da8174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/anotherApplications/SsoUnpaidView.vue"
export default component.exports